export default __webpack_public_path__ + "static/media/Award_Statue_SpaceGiraffe.256.8946dacd.png";